export default "__VITE_ASSET__C52XhnWv__"